import { SnackbarProvider } from "notistack";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { ScrollToTop } from "./Hooks/usePreventScrolling";
import backend from "./api";
import { setUserData } from "./redux-store/auth/actions";
import { setCompanyInfo } from "./redux-store/auth/actions";
import { useDispatch } from "react-redux";
import "./App.css";

// Website
import Home from "./MainWebsite/Pages/Home/Home";
import CustomerSignup from "./MainWebsite/Pages/Signup/CustomerSignup";
import Login from "./MainWebsite/Pages/Login/Login";
import ContactUs from "./MainWebsite/Pages/ContactUs/ContactUs";
import PrivacyPolicy from "./MainWebsite/Pages/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./MainWebsite/Pages/TermsOfService/TermsOfService";
import DataSecurity from "./MainWebsite/Pages/DataSecurity/DataSecurity";
import UniversalNavbar from "./MainWebsite/Pages/Home/Components/Navbar/Navbar";
import ManufacturerSignup from "./MainWebsite/Pages/Signup/ManufacturerSignup";
import Manufacturers from "./MainWebsite/Pages/Manufacturers/Manufacturers";
import Footer from "./MainWebsite/GlobalComp/Footer/Footer";

// Customer
import CustomerNavbar from "./Panels/Customer/Comp/Navbar/Navbar";
import CustomerSettings from "./Panels/Customer/Pages/Settings/Settings";
import Products from "./Panels/Customer/Pages/Products/Products";
import CustomerCollections from "./Panels/Customer/Pages/Collections/Collections";
import CustomerOnboarding from "./MainWebsite/Pages/Signup/CustomerOnboarding";
import CustomerInvite from "./MainWebsite/Pages/Signup/CustomerInvite";
// Manufacturer
import ManufacturerNavbar from "./Panels/Manufacturer/Comp/Navbar/Navbar";
import ManufacturerSettings from "./Panels/Manufacturer/Pages/Settings/Settings";
import ManufacturerOnboarding from "./MainWebsite/Pages/Signup/ManufacturerOnboarding";
import Listings from "./Panels/Manufacturer/Pages/Listings/Listings";
import AddListing from "./Panels/Manufacturer/Pages/AddListing/AddListing";
import ViewProduct from "./Panels/Customer/Pages/Products/ViewProduct/ViewProduct";
import ManufacturerInvite from "./MainWebsite/Pages/Signup/ManufacturerInvite";

import { useSelector } from "react-redux";


// -------------------------
// ROUTE WRAPPERS
// -------------------------
const RenderRouterWithMenuFooter = (Component) => (
  <>
    <UniversalNavbar />
    <Component />
    <Footer />
  </>
);

const CustomerWithSideBar = (Component) => (
  <>
    <CustomerNavbar />
    <Component />
    <Footer />
  </>
);

const ManufacturerWithSideBar = (Component) => (
  <>
    <ManufacturerNavbar />
    <Component />
    <Footer />
  </>
);

// -------------------------
// ROUTE GROUPS
// -------------------------
const MainWebsiteLoggedOutRoutes = () => (
  <Routes>
    <Route path="/" element={RenderRouterWithMenuFooter(Home)} />
    <Route path="/home" element={RenderRouterWithMenuFooter(Home)} />
    <Route path="/manufacturers" element={RenderRouterWithMenuFooter(Manufacturers)} />
    <Route path="/products" element={RenderRouterWithMenuFooter(Products)} />
    <Route path="/product/:id" element={ManufacturerWithSideBar(ViewProduct)} />
    <Route path="/signup/customer" element={<CustomerSignup />} />
    <Route path="/signup/manufacturer" element={<ManufacturerSignup />} />
    <Route path="/customer/:hashcode/:senderId/:inviteeId/:parentcompanyId" element={<CustomerInvite />} />
    <Route path="/manufacturer/:hashcode/:senderId/:inviteeId/:parentcompanyId" element={<ManufacturerInvite />} />

    <Route path="/login" element={<Login />} />
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-of-service" element={<TermsOfService />} />
    <Route path="/data-security" element={<DataSecurity />} />
    <Route path="*" element={RenderRouterWithMenuFooter(Home)} />
  </Routes>
);

const CustomerLoggedInRoutes = () => (
  <Routes>
    <Route path="/" element={CustomerWithSideBar(Home)} />
    <Route path="/settings/:tab" element={CustomerWithSideBar(CustomerSettings)} />
    <Route path="/collections" element={CustomerWithSideBar(CustomerCollections)} />
    <Route path="/products" element={CustomerWithSideBar(Products)} />
    <Route path="/product/:id" element={CustomerWithSideBar(ViewProduct)} />
    <Route path="/manufacturers" element={CustomerWithSideBar(Manufacturers)} />
    <Route path="*" element={CustomerWithSideBar(Home)} />
  </Routes>
);

const ManufacturerLoggedInRoutes = () => (
  <Routes>
    <Route path="/" element={ManufacturerWithSideBar(Home)} />
    <Route path="/onboarding/manufacturer" element={<ManufacturerOnboarding />} />
    <Route path="/listings" element={ManufacturerWithSideBar(Listings)} />
    <Route path="/listings/add" element={ManufacturerWithSideBar(AddListing)} />
    <Route path="/listings/:id/edit" element={ManufacturerWithSideBar(AddListing)} />
    <Route path="/products" element={ManufacturerWithSideBar(Products)} />
    <Route path="/product/:id" element={ManufacturerWithSideBar(ViewProduct)} />
    <Route path="/manufacturers" element={ManufacturerWithSideBar(Manufacturers)} />
    <Route path="/settings/:tab" element={ManufacturerWithSideBar(ManufacturerSettings)} />
    <Route path="*" element={ManufacturerWithSideBar(Home)} />
  </Routes>
);

const ManufacturerNotOnboardedRoutes = () => (
  <Routes>
    <Route path="/" element={<ManufacturerOnboarding />} />
    <Route path="/onboarding/manufacturer" element={<ManufacturerOnboarding />} />
    <Route path="*" element={<ManufacturerOnboarding />} />
  </Routes>
);


const CustomerNotOnboardedRoutes = () => (
  <Routes>
    <Route path="/" element={<CustomerOnboarding />} />
    <Route path="/onboarding/customer" element={<CustomerOnboarding />} />
    <Route path="*" element={<CustomerOnboarding />} />
  </Routes>
);


// -------------------------
// APP ROUTES CONTROLLER
// -------------------------
function AppRoutes() {
  // const [panel, setPanel] = useState(() => {
  //   // load from localStorage on init
  //   return localStorage.getItem("activePanel") || "main";
  // });
  const { user } = useSelector((s) => s.auth);

  const dispatch = useDispatch()
  const [panel, setPanel] = useState('customer')
  const onboarding = useSelector((state) => state.companyInfo.info);
  const companyId = user?.companyId;

  useEffect(() => {
    if (user) {
      const userId = user?._id;
      const fetchUser = async () => {
        const res = await backend.get(`/api/user/${userId}`);
        const updated = { ...user, ...res.data.data };
        await dispatch(setUserData(updated));
      }
      fetchUser();
    }
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {

        if (companyId) {
          // Check if companyName exists in database
          const response = await backend.get(`/api/onboarding/${companyId}`);
          // If response.data is not empty, companyName exists in database
          if (response?.data) {
            await dispatch(setCompanyInfo(response.data.data))
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures useEffect runs once on component mount



  const location = useLocation();
  const navigate = useNavigate();

  // check for ?panel= in URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const panelQuery = params.get("panel");

    if (panelQuery) {
      setPanel(panelQuery);
      localStorage.setItem("activePanel", panelQuery);
      // Optionally remove ?panel= from URL for cleaner navigation
      navigate(location.pathname, { replace: true });
    }
  }, [location.search]);

  // persist to localStorage
  useEffect(() => {
    localStorage.setItem("activePanel", panel);
  }, [panel]);

  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      classes={{ containerAnchorOriginTopRight: "snackTopRight" }}
    >
      <ScrollToTop />
      {!user && <MainWebsiteLoggedOutRoutes />}

      {(user?.role === "customer" || user?.invitedBy==="customer") && (
        user.onboarded
          ? <CustomerLoggedInRoutes />
          : <CustomerNotOnboardedRoutes />
      )}

      {(user?.role === "manufacturer" || user?.invitedBy==="manufacturer") && (
        user.onboarded
          ? <ManufacturerLoggedInRoutes />
          : <ManufacturerNotOnboardedRoutes />
      )}
    </SnackbarProvider>
  );
}

// -------------------------
// MAIN WRAPPER WITH ROUTER
// -------------------------
export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
